import { render, staticRenderFns } from "./DoctorSection.vue?vue&type=template&id=48e5eff0&"
import script from "./DoctorSection.vue?vue&type=script&lang=js&"
export * from "./DoctorSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports